import React            from 'react';
import Modal            from '../Fragments/Modal';
import PageSpinnerModal from '../Modals/PageSpinnerModal';


const SubmitButton = React.createClass({
    propTypes: {
        backLink:  React.PropTypes.func,
        saveForLater: React.PropTypes.bool,
        onClick:  React.PropTypes.func,
        label:  React.PropTypes.string.isRequired,
        loading: React.PropTypes.bool,
        spinnerMessage : React.PropTypes.string,
    },

    getDefaultProps() {
        return {
            spinnerMessage : 'Generating your quote...',
        };
    },

    getInitialState() {
        return {
            showSaveModal: false,
        };
    },

    backLinkHandler() {
        this.props.backLink();
    },

    openSaveModal() {
        this.setState({
            showSaveModal: true
        });
    },

    closeSaveModal: function() {
        this.setState({
            showSaveModal: false
        });
    },
   
    render() {
        let wrapperClass = 'form-navigation';
        if (this.props.saveForLater == true) {
            wrapperClass = 'form-navigation summary-step-navigation';
        }
        return (
            <div className={wrapperClass}  >
                <div onClick={this.props.onClick} className="btn btn-success btn-split-content">
                    <span>{this.props.label}</span>
                </div>
                {this.props.backLink ? <a onClick={this.backLinkHandler}>&lt; Back</a> : null}
                {this.props.saveForLater === true ? <a onClick={this.openSaveModal} className="save-link underline">Save for later</a> : null}

                <Modal
                    closeFunction={this.closeSaveModal}
                    title="Quote Saved"
                    bodyTemplate="save-quote"
                    isActive={this.state.showSaveModal}
                />

                {this.props.loading ?
                    <PageSpinnerModal
                        message={this.props.spinnerMessage}
                        ref="PageSpinnerModal"
                    />
                : null}
            </div>
        );
    }
});

export default SubmitButton;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/SubmitButton.js
 **/